/**
 * Web Style Import
 *
 */

import './style/dnb-img.scss'
